import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconBulk(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M5.076 4.617A1 1 0 0 1 6 4h12a1 1 0 0 1 .707 1.707l-6 6a1 1 0 0 1-1.414 0l-6-6a1 1 0 0 1-.217-1.09ZM8.414 6 12 9.586 15.586 6H8.414ZM5.293 9.293a1 1 0 0 1 1.414 0L12 14.586l5.293-5.293a1 1 0 1 1 1.414 1.414l-6 6a1 1 0 0 1-1.414 0l-6-6a1 1 0 0 1 0-1.414Zm1.414 5a1 1 0 0 0-1.414 1.414l6 6a1 1 0 0 0 1.414 0l6-6a1 1 0 0 0-1.414-1.414L12 19.586l-5.293-5.293Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
